// Cache for solution score responses, keyed by UUID
// This prevents duplicate scoring API calls for the same solution
const scoreCache = new Map();

export const getFromCache = (uuid) => scoreCache.get(uuid);
export const setInCache = (uuid, data) => scoreCache.set(uuid, data);
export const hasInCache = (uuid) => scoreCache.has(uuid);
export const clearCache = () => scoreCache.clear();
